import { put, call, fork, select, takeLatest } from 'redux-saga/effects'
import { FETCH_GUIDES } from './constants'
import { fetchGuidesApi } from './services'
import { fetchGuides } from './actions'
import languages from '../../constants/languages'
import { slugify } from '../../helpers/utils'

function* fetchGuidesWorker({ currentPhoneId }) {
  const state = yield select()
  const { preSaleFlag } = state.devicebits
  const language = languages[state.devicebits.language]
  const { customer } = state.devicebits
  const response = yield call(
    fetchGuidesApi,
    currentPhoneId,
    preSaleFlag,
    language,
    customer
  )

  const guides = addSlugs(response)
  yield put(fetchGuides.success(guides, currentPhoneId))
}

const addSlugs = guideResponse => (
  guideResponse[0].children.map(guide => ({
    ...guide,
    slug: slugify(guide.text),
  }))
)

function* guidesSaga() {
  yield takeLatest(FETCH_GUIDES.REQUEST, fetchGuidesWorker)
}

export default function* rootSaga() {
  yield fork(guidesSaga)
}



// WEBPACK FOOTER //
// ./src/containers/Guides/sagas.js